module.exports = __webpack_public_path__ + "static/media/zombie-scrapyard.tar.1c5b81e6.gz";